
<template>
    <div class="flex items-start space-x-4 text-base sm:text-sm">
        <div class="flex-none mt-1">
            <a :href="`/${monologue.urlSlug}`" :alt="monologue.showTitle" :title="monologue.showTitle" class="guide-img-container">
                <img class="object-cover w-8 rounded-lg shadow-lg"
                     :src="monologue.showLogo"
                :alt="`${monologue.showTitle} logo`" :title="`${monologue.showTitle} logo`">
            </a>
        </div>

        <div class="flex-grow">
            <a :href="`/${monologue.urlSlug}`" :alt="monologue.showTitle" :title="monologue.showTitle"
               class="block font-medium hover:underline">
                <h3 class="">{{ monologue.getExcerptOrDefault?.substring(0, 30) }}...</h3>
            </a>
            <p><a :href="`/${monologue.showId}`" :alt="monologue.showTitle" :title="monologue.showTitle"
                        class="text-xs text-slate-800">{{ monologue.showTitle }}</a>
                </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineProps} from "vue";
import {MonologueDto} from "@/dtos";

const props = defineProps<{
    monologue: MonologueDto;
}>();

const monologue: MonologueDto = props.monologue;

</script>
<style>

</style>